import { type FC } from 'react'
import { Outlet } from 'react-router-dom'

import { Spinner } from '@factorialco/deprecated-design-system'
import { ViewProcessesDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

export const Component: FC = () => {
  const { loading, data } = useQuery(ViewProcessesDocument)
  const canViewProcesses = () => Boolean(data?.processes._policies.processEditProcesses.can)

  if (loading) return <Spinner />

  return (
    <AuthorizeUser authorizeFn={canViewProcesses}>
      <Outlet />
    </AuthorizeUser>
  )
}
